import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const AdvancedPlanning = () => {
    const localizedHref = useLocalizedHref(
        "/software/jira/guides/advanced-roadmaps/overview#what-is-advanced-planning"
    );
    return (
        <div>
            <h2>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.modalContents.advanced-planning.title"
                    defaultMessage="Advanced Planning (Plans)"
                />
            </h2>
            <div>
                <p>
                    <FormattedMessage
                        id="JiraSoftwarePricingPage.modalContents.advanced-planning.body"
                        defaultMessage="Plans allow you to plan and track work across multiple teams and projects. Designed for cross-functional visibility and collaboration, advanced planning brings people, work, and goals into a shared space where deliverables are balanced against capacity, dependencies are flagged early on, and real-time updates are readily available to stakeholders."
                    />
                </p>
                <p>
                    <FormattedMessage
                        id="JiraSoftwarePricingPage.modalContents.advanced-planning.learnMore"
                        defaultMessage="<learnMore>Learn more</learnMore> about advanced planning."
                        values={{
                            ...DEFAULT_VALUES,
                            learnMore: (chunks) => (
                                <a
                                    data-event="clicked"
                                    data-event-component="linkButton"
                                    data-product-key="jiraSoftware"
                                    href={localizedHref}
                                >
                                    {chunks}
                                </a>
                            )
                        }}
                    />
                </p>
            </div>
        </div>
    );
};

export default AdvancedPlanning;
